import * as angular from 'angular';
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozArray} from "../persistence-layer/bringoz-array";

angular
  .module('bringoz.admin.commons')
  .factory('$bringozLocations', LocationsArrayFactory);

export type $bringozLocationsFactory = () => BringozArray<any>;


/* @ngInject */
function LocationsArrayFactory($bringozFactory: $bringozFactory,
                         LocationAPI: BringozApi,
                         Location_DS: DataStoreConfig,
                         Location_PN: PushNotificationsConfig) {

  function $bringozLocations() {
    return $bringozFactory<any>(null, LocationAPI, Location_DS, Location_PN);
  }

  return $bringozLocations;
}
